export default __webpack_public_path__ + "assets/images/99c89475924fd55c57660a50ecb8bc3d.png";